import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith('/en');

    const offerText = isEn ? 'Offer valid for' : 'Пропозиція діє ще';
    const daysText = isEn ? 'Days' : 'Днів';
    const hoursText = isEn ? 'Hours' : 'Годин';
    const minutesText = isEn ? 'Minutes' : 'Хвилин';
    const secondsText = isEn ? 'Seconds' : 'Секунд';

    const Completionist = () => <span>{isEn ? 'You are good to go!' : 'Час вийшов!'}</span>;

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return <Completionist />;
        } else {
            return (
                <div className="flex justify-between w-full max-w-[270px]">
                    <div className="text-center">
                        <div className="font-bold text-[36px] md:text-[46px] leading-tight">{days}</div>
                        <div className='text-sm'>{daysText}</div>
                    </div>
                    <div className="text-center">
                        <div className="font-bold text-[36px] md:text-[46px] leading-tight">{hours}</div>
                        <div className='text-sm'>{hoursText}</div>
                    </div>
                    <div className="text-center">
                        <div className="font-bold text-[36px] md:text-[46px] leading-tight">{minutes}</div>
                        <div className='text-sm'>{minutesText}</div>
                    </div>
                    <div className="text-center">
                        <div className="font-bold text-[36px] md:text-[46px] leading-tight">{seconds}</div>
                        <div className='text-sm'>{secondsText}</div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div>
            <div className="font-medium mb-2">
                Івент почнеться через
            </div>
            <Countdown
                date={new Date('2026-04-15T09:00:00')}
                renderer={renderer}
            />
        </div>
    );
}

export default MyCountdown;